export default function log() {
    console.log(...arguments);
}